import React from 'react';

/** Head counts for the Usuarios KPI row. */
export function useUserAnalytics(users) {
    return React.useMemo(() => {
        const totalUsers = users?.length || 0;
        const activeUsers = users?.filter((u) => u.active)?.length || 0;
        const inactiveUsers = totalUsers - activeUsers;

        // Count by role
        const gerentes = users?.filter((u) => u.userType === 'gerente')?.length || 0;
        const asesores = users?.filter((u) => u.userType === 'asesor')?.length || 0;
        const promotores = users?.filter((u) => u.userType === 'promotor')?.length || 0;
        const otros = totalUsers - gerentes - asesores - promotores;

        return { totalUsers, activeUsers, inactiveUsers, gerentes, asesores, promotores, otros };
    }, [users]);
}
